<template>
  <div class="root">
    <img class="logo" src="@/assets/logo.svg" />
    <div class="content">
      <div class="upper">
        <p>ログインするとポイントがたまります！</p>
        <ButtonTextLink
          text="ログインして前回の続きから"
          @click-text="onClickSignin"
        />
        <ButtonTextLink
          text="新規登録してポイントをためる"
          @click-text="onClickSignup"
        />
      </div>
      <div class="lower">
        <p>ログインなしでも、経路検索など一部機能がご利用いただけます</p>
        <ButtonTextLink
          text="ログインせずに利用する<br/>※ ポイントに関連する機能はご利用いただけません"
          @click-text="onClickNoLogin"
        />
        <p class="sub">※ 後からマイページで新規登録・ログインが可能です</p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations } from "vuex";
import ButtonTextLink from "@/components/Atoms/ButtonTextLink";
import Firebase from "./../../firebase";

export default {
  name: "branch",
  components: {
    ButtonTextLink,
  },
  computed: {},
  data() {
    return {
      currentPage: 1,
    };
  },
  methods: {
    ...mapMutations(["loadingStartMini", "loadingEndMini", "setModal"]),
    onClickSignin() {
      this.setModal("signin");
    },
    onClickSignup() {
      this.setModal("signup");
    },
    async onClickNoLogin() {
      this.loadingStartMini();
      await Firebase.createRegistraion();
      this.loadingEndMini();
      this.$router.push({ name: "Settings" });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./../../unified.scss";
.root {
  justify-content: center;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.logo {
  height: 8vh;
  margin: 5vh 0;
}
.content {
  margin: 0 1rem;
  p {
    text-align: center;
  }
}
.upper {
  margin-bottom: 5vh;
  padding-bottom: 5vh;
  border-bottom: 1px solid #c3c3c3;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/Branch.vue